import { hot } from '../util/react-hot-ts';
import { launchPanelApp } from './lib/PanelApp';

import Feedback from './pages/feedback/Feedback';
hot(module)(launchPanelApp(Feedback, {}));
